<template>
    <g>
        <path d="M9 13.5L15 13.5" :stroke="iconFill" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M9 9.50003L15 9.5" :stroke="iconFill" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M5 21.5V5.5C5 4.96957 5.21071 4.46086 5.58579 4.08579C5.96086 3.71071 6.46957 3.5 7 3.5H17C17.5304 3.5 18.0391 3.71071 18.4142 4.08579C18.7893 4.46086 19 4.96957 19 5.5V21.5L16 19.5L14 21.5L12 19.5L10 21.5L8 19.5L5 21.5Z"
            :stroke="iconFill"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </g>
</template>
<script>
export default {
    name: "PaySlip2425",
    props: {
        iconFill: {
            type: String,
            default: "#000000",
        },
    },
};
</script>
